<div class="hero-tile">

  <!-- Spinner while loading -->
  <ng-container *ngIf="!initialized">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="initialized && model != null">
    <div *ngIf="mode === UserBoardComponentMode.Edit; else viewMode">

      <!-- Editable Header -->
      <div class="header">
        <bhub-tile-metric-picker
          [(value)]="model.header.value"
          [(type)]="model.header.type"
          [availableMetrics]="availableMetrics"
        ></bhub-tile-metric-picker>


        <!-- Hide Notifications for now-->
        <!-- <div class="header-icons">
          <mat-label>Header Icons</mat-label>
          <mat-chip-list>
            <mat-chip *ngFor="let icon of model.headerIcons" removable (removed)="removeHeaderIcon(icon)">
              <mat-icon>{{ icon }}</mat-icon>
              <button mat-icon-button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
          <mat-form-field appearance="fill">
            <mat-label>Add Icon</mat-label>
            <input matInput [(ngModel)]="newIcon" (keyup.enter)="addHeaderIcon()" />
          </mat-form-field>
        </div> -->
      </div>

      <!-- Editable Hero Metric -->
      <div class="hero-number">
        <bhub-tile-metric-picker
          [(value)]="model.heroRow.value"
          [(type)]="model.heroRow.type"
          [availableMetrics]="availableMetrics"
        ></bhub-tile-metric-picker>

        <!-- Preview of the selected metric -->
        <div *ngIf="selectedHeroMetric" >
          <h3>{{ selectedHeroMetric.metricName }}</h3>
          <!-- Add more properties for the preview as needed -->
        </div>
      </div>


      <!-- Editable Footer Rows -->
      <div class="footer">
        <div *ngFor="let row of model.footerRows; let i = index" class="footer-row">
          <div *ngFor="let item of row; let j = index" class="footer-item">
            <bhub-tile-metric-picker
              [(value)]="model.footerRows[i][j].value"
              [(type)]="model.footerRows[i][j].type"
              [availableMetrics]="availableMetrics"
            ></bhub-tile-metric-picker>
          </div>
          <button mat-icon-button color="warn" (click)="removeFooterRow(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <button mat-raised-button (click)="addFooterRow()">Add Footer Row</button>
      </div>

    </div>

    <!-- View Mode -->
    <ng-template #viewMode>
      <div *ngIf="mode === UserBoardComponentMode.Preview" class="preview-header">
        <mat-icon style="cursor: pointer" (click)="onPreviewButtonClick('edit')">edit</mat-icon>
        <mat-icon style="cursor: pointer" (click)="onPreviewButtonClick('delete')">delete</mat-icon>
      </div>
      <div class="header">
        <div class="header-text">{{ model.header.value }}</div>
        <div class="header-icons">
          <ng-container *ngFor="let icon of model.headerIcons">
            <mat-icon (click)="onIconClick(icon)">{{ icon }}</mat-icon>
          </ng-container>
        </div>
      </div>

      <div class="hero-number">
        {{ model.heroRow.value }}
      </div>

      <div class="footer">
        <div class="footer-row" *ngFor="let row of model.footerRows">
          <div class="footer-item" *ngFor="let item of row">
            {{ item.value }}
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>

</div>

<!-- <div class="hero-tile">

  <ng-content *ngIf="!initialized">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-content >

  <ng-content *ngIf="initialized">
    <div class="header">
      <div class="header-text">{{ model.headerText }}</div>
      <div class="header-icons">
        <ng-container *ngFor="let icon of model.headerIcons">
          <mat-icon>{{ icon }}</mat-icon>
        </ng-container>
      </div>
    </div>

    <div class="hero-number">
      {{ model.heroRow }}
    </div>

    // Footer //
    <div class="footer">
      <div class="footer-row" *ngFor="let row of model.footerRows">
        <div class="footer-item" *ngFor="let item of row">
          {{ item }}
        </div>
      </div>
    </div>

  </ng-content>

</div> -->
